import moment from 'moment'
import React from 'react'

import Modal from "../reusable/modal"

const Batches = ({ toggle, visible, rec }) => {
    return (
        <Modal
            w={ 450 }
            title="Available Batches"
            toggle={toggle}
            visible={visible}>
            <p className="text-gray-500 text-xs italic">Batches of { rec?.item?.name }</p>
            <div className="w-full bg-white">
                {
                    rec?.variations?.length > 0 ?
                        <table className="table-auto w-full mb-3">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Batch No.</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Quantity</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Expiry</div>
                                    </th>
                                    <th />
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    rec?.variations.map((variant, key) => {
                                        const expiry = variant?.expiry ? moment(variant.expiry) : null
                                        const daysToExpiry = expiry ? expiry.startOf('day').diff(moment().startOf('day'), 'days') : null
                                        const expired = daysToExpiry !== null && daysToExpiry < 0

                                        return (
                                        <tr key={`${variant?.batchNo}-${key}`}>
                                            <td className="p-2 text-left">{key + 1}</td>
                                            <td className="p-2 text-left">{ variant?.batchNo }</td>
                                            <td className="p-2 text-left">{variant.total} {rec?.item?.issuedIn}</td>
                                            <td className="p-2 text-left">
                                                {
                                                    expiry ?
                                                        <span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${expired ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
                                                            {expiry.format('DD MMM YYYY')}
                                                        </span>
                                                        :
                                                        '—'
                                                }
                                            </td>
                                            {/* <td onClick={() => deleteIngredient(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td> */}
                                        </tr>
                                    )})
                                }
                            </tbody>
                        </table>
                    :
                        <div className="text-center my-4">
                            <h3>No variations were found</h3>
                        </div>
                }
            </div>
            <div className="flex justify-end">
                <button onClick={ toggle } type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default Batches
